export default function TpaGridSkeleton() {
  return (
    <div className="mt-6">
      <div className="h-6 w-32 bg-gray-200 rounded mb-4 animate-pulse" />
      <div className="flex flex-wrap gap-4">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className="h-12 w-32 bg-gray-200 rounded animate-pulse"
          />
        ))}
      </div>
    </div>
  );
}
